import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../components/ui/Button';
import Icon from '../components/AppIcon';

const BulkImportTemplate = () => {
  const { t } = useTranslation();
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/bulk_import_template.csv';
    link.setAttribute('download', 'bulk_import_template.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground">{t('bulk_import.title')}</h1>
          <p className="text-muted-foreground">{t('bulk_import.subtitle')}</p>
        </div>
      </div>

      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-4">
          <Icon name="FileText" size={48} className="text-primary" />
          <div>
            <h3 className="text-lg font-semibold">{t('bulk_import.template_title')}</h3>
            <p className="text-muted-foreground mt-1">
              {t('bulk_import.columns_intro')}
            </p>
            <ul className="list-disc list-inside mt-2 text-sm text-muted-foreground">
              <li>{t('bulk_import.category')}</li>
              <li>{t('bulk_import.model_name')}</li>
              <li>{t('bulk_import.serial_number')}</li>
              <li>{t('bulk_import.purchase_price')}</li>
              <li>{t('bulk_import.purchase_date')}</li>
              <li>{t('bulk_import.warranty_expiry')}</li>
              <li>{t('bulk_import.supplier')}</li>
            </ul>
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <Button onClick={handleDownload} iconName="Download">
            {t('bulk_import.download_template')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkImportTemplate;
